import React from 'react';
import { Button as AntButton } from 'antd';
import { ButtonProps, ButtonType } from 'antd/lib/button';
import './style.scss'; // Global variant classes

// Supported variants
export type ButtonVariant =
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'secondary-destructive'
    | 'tertiary-destructive';

export interface ButtonComponentProps  // Omit so we control them
    extends Omit<ButtonProps, 'type' | 'danger'> {
    variant?: ButtonVariant;
    children: React.ReactNode;
}

export function Button({
    variant = 'secondary',
    children,
    className,
    ...antProps
}: ButtonComponentProps) {
    // Map variant to Ant Design props (for backwards compatibility and base functionality)
    const props: { type: ButtonType; danger?: boolean } = (() => {
        switch (variant) {
            case 'primary':
                return { type: 'primary' };
            case 'secondary':
                return { type: 'default' };
            case 'tertiary':
                return { type: 'text' };
            case 'secondary-destructive':
                return { type: 'default', danger: true };
            case 'tertiary-destructive':
                return { type: 'text', danger: true };
        }
    })();

    // Add variant class (following Tag component pattern)
    const variantClass = `button_${variant.replace(/-/g, '_')}`;
    const combinedClassName = className
        ? `${variantClass} ${className}`
        : variantClass;

    return (
        <AntButton
            type={props.type}
            danger={props.danger}
            className={combinedClassName}
            {...antProps}
        >
            {children}
        </AntButton>
    );
}
